import * as React from 'react';
import { HeaderUserImage } from '../../standalone-header/header-user-details/header-user-image';
import { composer } from '../../../component-decorators/composer';
import { Box, Button, Text, TextButton } from 'wix-style-react';
import { useConfigContext } from '../../../config-context';
export var MobileMenuUserDetails = composer()
    .withMarketplaceStore()
    .withExperiments()
    .compose(function (_a) {
    var marketplaceStore = _a.marketplaceStore;
    var base = marketplaceStore.route.currentUrl
        ? marketplaceStore.route.currentUrl
        : 'www.wix.com/app-market';
    // tslint:disable-next-line: react-hooks-nesting
    var locale = useConfigContext().locale;
    return marketplaceStore.userName ? (React.createElement(Box, { align: "space-between", verticalAlign: "middle" },
        React.createElement(Box, { verticalAlign: "middle" },
            React.createElement(HeaderUserImage, { marginLeft: "0" }),
            React.createElement(Text, { dataHook: "username-mobile-menu" }, marketplaceStore.userName)),
        React.createElement(LogoutLink, { signoutLink: "https://www.wix.com/signout?redirectTo=" + base
                .split('/app-market')[0]
                .concat('/app-market') }))) : (React.createElement(LoginButton, { signinLink: "https://users.wix.com/signin?loginDialogContext=login&referralInfo=HEADER&overrideLocale=" + locale + "&postLogin=" + base
            .split('/app-market')[0]
            .concat('/app-market') + "&postSignUp=" + base
            .split('/app-market')[0]
            .concat('/app-market') }));
});
var LogoutLink = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, signoutLink = _a.signoutLink;
    return (React.createElement(TextButton, { as: "a", href: signoutLink, dataHook: "logout" }, t('standalone.header.logout')));
});
var LoginButton = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, signinLink = _a.signinLink;
    return (React.createElement(Button, { priority: "secondary", onClick: function () { return (window.location.href = signinLink); } }, t('standalone.header.login')));
});
//# sourceMappingURL=mobile-menu-user-details.js.map